<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4">
      <h2 *ngIf="loadingEventType">Loading...</h2>

      <ng-container *ngIf="!loadingEventType">

        <h4 class="mb-0">Scheduled Event View Columns</h4>

        <small class="text-muted d-block mb-3">
          Configure the information displayed for each participant when on an individual event page.
        </small>

        <div class="row mx-0">
          <div class="col-md-10 col-lg-8 col-xl-6 border-rounded-10 mb-2 px-2 py-1">
            <span class="d-block">Name</span>
            <small class="text-muted d-block" style="margin-top: -3px;">Reservation Field</small>
          </div>
        </div>

        <div class="row mx-0"
             *ngFor="let column of eventType.scheduled_events_columns; let idx = index; let first = first; let last = last;">
          <div class="col-md-10 col-lg-8 col-xl-6 border-rounded-10 mb-2 px-2 py-1">
            <div class="float-right" style="padding-top: 2px;">
              <button class="btn btn-secondary btn-sm mr-1 my-auto"
                      title="Move To Top"
                      [disabled]="first"
                      [class.disabled]="first"
                      (click)="shiftColumnToExtreme(idx, true)">
                &uarr;&uarr;
              </button>
              <button class="btn btn-secondary btn-sm mr-1"
                      title="Move Up 1"
                      [disabled]="first"
                      [class.disabled]="first"
                      (click)="shiftColumnByOne(idx, true)">
                &uarr;
              </button>
              <button class="btn btn-secondary btn-sm mr-1"
                      title="Move Down 1"
                      [disabled]="last"
                      [class.disabled]="last"
                      (click)="shiftColumnByOne(idx, false)">
                &darr;
              </button>
              <button class="btn btn-secondary btn-sm mr-1"
                      title="Move To Bottom"
                      [disabled]="last"
                      [class.disabled]="last"
                      (click)="shiftColumnToExtreme(idx, false)">
                &darr;&darr;
              </button>
              <button class="btn btn-danger btn-sm"
                      title="Remove Column"
                      (click)="removeColumn(idx)">
                X
              </button>
            </div>
            <span class="d-block">{{ getScheduledEventsColumnHeaderName(column) }}</span>
            <small class="text-muted d-block" style="margin-top: -3px;">{{ getColumnTypeName(column) }}</small>
          </div>
        </div>

        <button class="btn btn-success" style="border-radius: 10px;"
                [disabled]="loadingInit()"
                [class.disabled]="loadingInit()"
                (click)="openAddColumnModal()">
          Add Column
        </button>

      </ng-container>

      <div class="mt-3">
        <div class="float-right">
          <button class="btn btn-primary"
                  *ngIf="eventType?.schedule_type === ScheduleType.rolling"
                  [routerLink]="['/events/setup/edit/' + this.eventTypeIdInt.toString() + '/waitlist']"
                  [disabled]="loadingSave" [class.disabled]="loadingSave">
            Continue
          </button>
          <button class="btn btn-primary"
                  *ngIf="eventType?.schedule_type !== ScheduleType.rolling"
                  [routerLink]="['/events/setup/edit/' + this.eventTypeIdInt.toString() + '/emails']"
                  [disabled]="loadingSave" [class.disabled]="loadingSave">
            Continue
          </button>
        </div>
        <button class="btn btn-secondary"
                [routerLink]="['/events/setup/event-types']"
                [queryParams]="{status: eventType?.status}"
                [disabled]="loadingSave" [class.disabled]="loadingSave">
          Back
        </button>
      </div>
    </div>
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingSave">
      Saving changes...
    </div>
  </div>
</div>



